module.exports = __webpack_public_path__ + "img/full0-min.161fe589.png";